var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "48px_cryptography",
    clipPath: "url(#clip0_18_670)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5178 4.03762L18.4166 1.93649H15.1666V6.81149L18.4166 10.1265V13.8532",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.75 8.43649C10.6475 8.43649 11.375 7.70896 11.375 6.81149C11.375 5.91403 10.6475 5.18649 9.75 5.18649C8.85254 5.18649 8.125 5.91403 8.125 6.81149C8.125 7.70896 8.85254 8.43649 9.75 8.43649Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.25 22.5198C17.1475 22.5198 17.875 21.7923 17.875 20.8948C17.875 19.9974 17.1475 19.2698 16.25 19.2698C15.3525 19.2698 14.625 19.9974 14.625 20.8948C14.625 21.7923 15.3525 22.5198 16.25 22.5198Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.08337 14.3948V8.43649L7.58337 1.93649H11.9167",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.60171 7.95984L4.33337 12.2282V17.6448H1.08337",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M14.0833 25.7698H18.4166L24.9166 19.2698V13.3115",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.48169 23.6681L7.58336 25.7698H10.8334V20.8948L7.58336 17.6448V13.8531",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.3983 19.7465L21.6666 15.4782V10.0615H24.9166",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13 15.4781C13.8975 15.4781 14.625 14.7506 14.625 13.8531C14.625 12.9557 13.8975 12.2281 13 12.2281C12.1025 12.2281 11.375 12.9557 11.375 13.8531C11.375 14.7506 12.1025 15.4781 13 15.4781Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M21.6666 6.81149C22.5641 6.81149 23.2916 6.08396 23.2916 5.18649C23.2916 4.28903 22.5641 3.56149 21.6666 3.56149C20.7692 3.56149 20.0416 4.28903 20.0416 5.18649C20.0416 6.08396 20.7692 6.81149 21.6666 6.81149Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M4.33337 24.1448C5.23084 24.1448 5.95837 23.4173 5.95837 22.5198C5.95837 21.6224 5.23084 20.8948 4.33337 20.8948C3.43591 20.8948 2.70837 21.6224 2.70837 22.5198C2.70837 23.4173 3.43591 24.1448 4.33337 24.1448Z",
    stroke: "#111111",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_670"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(0 0.853149)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg16);
export default __webpack_public_path__ + "static/media/16.8c3aa67780aadc92c258af5ffdcb0002.svg";
export { ForwardRef as ReactComponent };